<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__accent sp-margin__bottom-x2">{{ 'GENERAL.NOTE_LABEL' | translate }}</h3>

    <form [formGroup]="note_form_group">
      <mat-form-field class="sp-width__full sp-margin__bottom-x2" appearance="fill" color="accent">
        <mat-label>{{ 'GENERAL.NOTE_LABEL' | translate }}</mat-label>
        <textarea matInput rows="4" formControlName="note"></textarea>
      </mat-form-field>

      <app-shared-button
        class="sp-width__full"
        [button_class]="'sp-button__main'"
        [spinner_class]="'sp-spinner__main'"
        [cta]="'GENERAL.CONFIRM_CTA'"
        [is_disabled]="is_saving_note"
        [is_spinner_visible]="is_saving_note"
        (click)="onSaveClick()"></app-shared-button>
    </form>
  </div>
</div>
